<div class="d-flex flex-column align-items-center justify-content-center my-2" *ngIf="localImages > 0">
    <app-file-drop class="w-100" [extensions]="extensions" [types]="types" (onSelect)="onSelect($event)">
        <div class="my-2 d-flex flex-column align-items-center justify-content-center">
            <div class="mb-3">Drag & drop {{localImages}} images or the folder of {{localImages}} images here</div>
            <div class="mb-3" style="font-weight: bold;">OR</div>
            <app-input-file accept="image/png,image/jpeg" label="+ Choose Images" [formControl]="import" [disabled]="disabled" multiple="true" [classes]="['btn--purple', 'mb-3']"></app-input-file>
        </div>
    </app-file-drop>
</div>
<div class="error-list position-relative mb-2" *ngIf="errors.length">
    <div class="error-list--background"></div>
    <div class="error-title">Some selected images contain errors. Please fix the errors or remove the files with errors to proceed.</div>
</div>
<div class="file-list position-relative mt-4">
    <div class="file-list__content">
        <div class="file-card mb-2" *ngFor="let image of missed; let i = index;">
            <div class="row">
                <div class="col-6 d-flex">
                    <div class="file-card__icon mr-2">
                        <app-icon-file-small></app-icon-file-small>
                    </div>
                    <div class="file-card__name text-truncate">{{image.name}}</div>
                </div>
                <div class="col-6 d-flex justify-content-end">
                    <div class="file-card__error mr-2 text-truncate">Row: {{image.key + 2}}, Image File not present</div>
                </div>
            </div>
        </div>
        <div class="file-card mb-2" *ngFor="let image of files; let i = index;">
            <div class="row">
                <div class="col-6 d-flex">
                    <div class="file-card__icon mr-2">
                        <app-icon-file-small></app-icon-file-small>
                    </div>
                    <div class="file-card__name text-truncate">{{image.file.name}}</div>
                </div>
                <div class="col-6 d-flex justify-content-end" *ngIf="!image.uploaded">
                    <div class="file-card__error mr-2 text-truncate" *ngIf="image.error">{{image.error}}</div>
                    <div class="file-card__size mr-2" *ngIf="!image.error">{{getFileSize(image.file)}}</div>
                    <app-icon-trash class="cursor-pointer" *ngIf="!image.error" (click)="removeImage(image.file)"></app-icon-trash>
                </div>
                <div class="col-6 d-flex justify-content-end" *ngIf="image.uploaded">
                    <app-icon-success class="mr-0"></app-icon-success>
                </div>
            </div>
        </div>
    </div>
</div>
